import React, { useEffect, useState } from "react";
import { auth } from "../firebaseConfig";
import { User } from "firebase/auth";
import { AuthContext } from "../context/AuthContext";
import {initRedditPixel} from "../lib/helpers/redditPixelHelper.ts";
import {setSentryUser} from "../lib/sentry.ts";

const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user !== null) {
       initRedditPixel(user.email);
       setSentryUser(user.uid, user.email ?? undefined);
      }
      setUser(user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
